import { FormikState, useFormik } from 'formik';
import { string as yupString } from 'yup';
import orderBy from 'lodash/orderBy';


import { Client } from '../../administration/clientPage/types';
import RadioFormik from '../../shared/forms/radio/radioFormik.component';
import SelectFormik from '../../shared/forms/select/selectFormik.component';
import { hideField } from '../../shared/forms/constants';
import { YesNoFlag } from '../../shared/types';

const restrictClientsOptions = [
  {
    label: 'All clients',
    value: 'N',
  },
  {
    label: 'Selected clients',
    value: 'Y',
  },
];


export const createHelpContentSettingsSchema = (clients: Client[], currentClientId: Client['clientId']) => [
  {
    name: 'restrictClients',
    component: RadioFormik,
    meta: { label: 'Show this help page to', options: restrictClientsOptions },
    options: { yupType: yupString() },
    additionalProps: {
      horizontal: false,
      onAfterChange: (value: YesNoFlag, { formik }: { formik: ReturnType<typeof useFormik> }) => {
        if (value === YesNoFlag.Y) {
          formik.setFieldValue('clients', [currentClientId]);
        }
      },
    },
  },
  {
    name: 'clients',
    component: SelectFormik,
    conditions: [
      {
        when: ({ formik }: { formik: FormikState<any> }) => formik.values.restrictClients === 'N',
        then: hideField,
      },
    ],
    meta: {
      label: 'Clients',
      options: orderBy(clients.map(({ clientId, name }) => ({
        label: clientId === currentClientId ? `${name} (Current client)` : name,
        value: clientId,
      })), 'label'),
    },
    additionalProps: {
      multiple: true,
      sortBySelected: true,
      showSearchOnToggle: true,
    },
  },
];
